<ra-modal [title]="'shared.modalListTemplates.title' | translate" [size]="'large'" (close)="close.emit()">
    @if (loading()) {
        <div class="container-loading">
            <ra-loading [message]="'shared.modalListTemplates.loading' | translate"/>
        </div>
    }
    @else {
        <!-- Message -->
        <p class="ra-label-s description-message">{{ message() || ('shared.modalListTemplates.hint' | translate) }}</p>

        <!-- Input search -->
        <div class="container-input-search">
            <ra-input 
                [id]="'input-search-modal-list-templates'"
                [placeholder]="'shared.modalListTemplates.searchPlaceholder' | translate" 
                [formControl]="searchControl" 
                [showRequiredOrOptional]="false"
            />
        </div>

        @if (templatesFiltered().length === 0) {
            <div class="container-empty">
                <ra-empty [message]="'shared.modalListTemplates.emptyMessage' | translate"/>
            </div>
        }
        @else {
            <!-- List -->
            <div class="container-clients-list">
                @for (template of templatesFiltered(); track $index; let i = $index) {
                    <ra-fillet
                        [id]="'fillet-template-' + i"
                        [icon]="'document-copy'"
                        [title]="template.title"
                        [clickMessage]="'shared.modalListTemplates.clickSelect' | translate"
                        [description]="(template.title) || ('shared.modalListTemplates.documentTitleNotFound' | translate)"
                        (click)="selectTemplate.emit(template)"
                    />
                }
            </div>
        }
    }
</ra-modal>
